import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type WhatsNewEmailRecipientFragment = { __typename?: 'WhatsNewEmailRecipient', tenantId: string, email: string, subscribed: boolean };

export type GetMyWhatsNewEmailQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyWhatsNewEmailQuery = { __typename?: 'Query', myWhatsNewEmail: boolean };

export const WhatsNewEmailRecipientFragmentDoc = new TypedDocumentString(`
    fragment WhatsNewEmailRecipient on WhatsNewEmailRecipient {
  tenantId
  email
  subscribed
}
    `, {"fragmentName":"WhatsNewEmailRecipient"});
export const GetMyWhatsNewEmailDocument = new TypedDocumentString(`
    query GetMyWhatsNewEmail {
  myWhatsNewEmail
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMyWhatsNewEmail: build.query<GetMyWhatsNewEmailQuery, GetMyWhatsNewEmailQueryVariables | void>({
      query: (variables) => ({ document: GetMyWhatsNewEmailDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMyWhatsNewEmailQuery, useLazyGetMyWhatsNewEmailQuery } = injectedRtkApi;
